export const NODE_PALETTE = [
  { type: "message", labelKey: "message", color: "#1976d2" },
  { type: "audio", labelKey: "audio", color: "#00897b" },
  { type: "video", labelKey: "video", color: "#5e35b1" },
  { type: "button", labelKey: "button", color: "#7b1fa2" },
  { type: "list", labelKey: "list", color: "#c2185b" },
  { type: "input", labelKey: "input", color: "#f57c00" },
  { type: "wait_reply", labelKey: "wait_reply", color: "#5d4037" },
  { type: "condition", labelKey: "condition", color: "#ef6c00" },
  { type: "delay", labelKey: "delay", color: "#00838f" },
  { type: "api_call", labelKey: "api_call", color: "#303f9f" },
  { type: "ai_reply", labelKey: "ai_reply", color: "#6a1b9a" },
  { type: "end", labelKey: "end", color: "#d32f2f" }
];

export const NODE_COLORS = {
  start: "#2e7d32",
  message: "#1976d2",
  audio: "#00897b",
  video: "#5e35b1",
  button: "#7b1fa2",
  list: "#c2185b",
  input: "#f57c00",
  wait_reply: "#5d4037",
  condition: "#ef6c00",
  delay: "#00838f",
  api_call: "#303f9f",
  ai_reply: "#6a1b9a",
  loop: "#00695c",
  subflow: "#ad1457",
  end: "#d32f2f"
};

export const defaultNodeData = type => {
  switch (type) {
    case "message":
      return { label: "Mensagem", text: "Olá!", mediaType: "text" };
    case "audio":
      return {
        label: "Áudio",
        text: "",
        mediaType: "audio",
        asVoiceNote: true,
        mediaPath: "",
        mediaUrl: "",
        fileName: ""
      };
    case "video":
      return {
        label: "Vídeo",
        text: "",
        mediaType: "video",
        mediaPath: "",
        mediaUrl: "",
        fileName: ""
      };
    case "wait_reply":
      return {
        label: "Esperar resposta",
        prompt: "",
        variableName: "lastReply"
      };
    case "button":
      return {
        label: "Botões",
        buttonMode: "reply",
        text: "Escolha uma opção:",
        buttons: [
          { id: "btn_a", label: "Opção A" },
          { id: "btn_b", label: "Opção B" }
        ],
        cta: {
          body: "Toque no botão para continuar:",
          displayText: "Abrir link",
          url: "https://"
        }
      };
    case "list":
      return {
        label: "Lista",
        text: "Escolha na lista:",
        buttonText: "Ver opções",
        sections: [
          {
            title: "Opções",
            rows: [
              { id: "row_1", title: "Item 1", description: "" },
              { id: "row_2", title: "Item 2", description: "" }
            ]
          }
        ]
      };
    case "input":
      return {
        label: "Entrada",
        prompt: "Digite sua resposta:",
        variableName: "resposta"
      };
    case "condition":
      return {
        label: "Condição",
        leftOperand: "{{lastInput}}",
        operator: "contains",
        rightOperand: ""
      };
    case "delay":
      return { label: "Delay", seconds: 5 };
    case "api_call":
      return {
        label: "API",
        method: "GET",
        url: "https://",
        bodyTemplate: "",
        responsePath: "",
        saveAs: "apiResult"
      };
    case "ai_reply":
      return {
        label: "IA",
        text: "Use a IA do Whaticket fora do fluxo, ou configure um nó Mensagem."
      };
    case "end":
      return { label: "Fim", handoff: false };
    case "start":
      return { label: "Início" };
    default:
      return { label: type };
  }
};

export const buildDefaultGraph = () => ({
  version: 2,
  nodes: [
    {
      id: "start",
      type: "start",
      position: { x: 80, y: 180 },
      data: defaultNodeData("start")
    },
    {
      id: "msg1",
      type: "message",
      position: { x: 320, y: 180 },
      data: defaultNodeData("message")
    },
    {
      id: "end",
      type: "end",
      position: { x: 560, y: 180 },
      data: defaultNodeData("end")
    }
  ],
  edges: [
    { id: "e-start-msg1", source: "start", target: "msg1" },
    { id: "e-msg1-end", source: "msg1", target: "end" }
  ]
});

export const graphToFlowState = graph => {
  const nodes = (graph?.nodes || []).map(n => ({
    id: n.id,
    type: n.type || "message",
    position: n.position || { x: 0, y: 0 },
    data: { ...(n.data || {}) }
  }));
  const edges = (graph?.edges || []).map((e, idx) => ({
    id: e.id || `e-${e.source}-${e.target}-${idx}`,
    source: e.source,
    target: e.target,
    sourceHandle: e.sourceHandle || undefined,
    targetHandle: e.targetHandle || undefined,
    label: e.label || undefined,
    markerEnd: { type: "arrowclosed" }
  }));
  return { nodes, edges };
};

export const flowStateToGraph = (nodes, edges) => ({
  version: 2,
  nodes: (nodes || []).map(n => ({
    id: n.id,
    type: n.type,
    position: n.position || { x: 0, y: 0 },
    data: { ...(n.data || {}) }
  })),
  edges: (edges || []).map(e => ({
    id: e.id,
    source: e.source,
    target: e.target,
    sourceHandle: e.sourceHandle || null,
    targetHandle: e.targetHandle || null,
    label: e.label
  }))
});
